import { useEffect, useState } from 'react';

/** Tracks a CSS media query. Without matchMedia (tests, old browsers) it returns `fallback`. */
export default function useMediaQuery(query: string, fallback = true) {
  const get = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    if (list.addEventListener) list.addEventListener('change', update);
    else list.addListener(update);
    return () => {
      if (list.removeEventListener) list.removeEventListener('change', update);
      else list.removeListener(update);
    };
  }, [query]);
  return matches;
}
